import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";
import i18next from 'i18next';
/**
 * PLMSetting
 */
export type PLM_CSV_SET = {
  ///PLM連携INDEX
  PLM_INDEX: number;
  ///APLM名称
  PLM_NAME: string;
  /// 保存先フォルダ
  PLM_CSV_PATH: string;
  /// ユーザID
  PLM_USERID: string;
  /// パスワード
  PLM_PASSWD: string;
  /// IPアドレス
  PLM_IPADR: string;
  /// 送信時刻
  PLM_HHMM: string;
  /// 要求フラグ
  PLM_REQ_FLG: number;
  /// ステータス
  PLM_STAT: number;
  ///  リトライ回数
  PLM_RETRY: number;

  /// 連番
  indexNo: number;
  /// 編集フラグ
  isEdit: boolean;

  /// 要求フラグ編集可能フラグ
  isEditPlmState: boolean;

};

/**
 *
 * @returns
 */
export const CreatePLMSetting = (): PLM_CSV_SET => {

  let ret: PLM_CSV_SET = {
    PLM_INDEX: 0,
    PLM_NAME: "",
    PLM_CSV_PATH: "",
    PLM_USERID: "",
    PLM_PASSWD: "",
    PLM_IPADR: "0.0.0.0",
    PLM_HHMM: "00:00",
    PLM_REQ_FLG: 0,
    PLM_STAT: 0,
    PLM_RETRY: 0,
    indexNo: 0,
    isEdit: true,
    isEditPlmState: true,
  };
  return ret;
}

//EMC設定データ取得
export const GetPLMSettings = (): Promise<PLM_CSV_SET[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLMSetting/")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: PLM_CSV_SET[]) => {
        if (result != null) {
          if (result.length !== 0) {
            result.map((row, index) => {
              //連番付与
              row.indexNo = index + 1;
              //ステータス編集可能フラグ
              if (row.PLM_REQ_FLG !== null && row.PLM_REQ_FLG !== 0) {
                row.isEditPlmState = false;
              }
              else {
                //データ取得時にOFFの場合
                row.isEditPlmState = true;
              }
            });
          }
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

export const PutPLMSettings = (targetList: PLM_CSV_SET[], deleteList: number[]): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLMSetting", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ PLMSettingList: targetList, DeltePLMSettingPlmIndexList: deleteList }),
    })
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: ResponceDataType) => {
        if (result.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          resolve(result);
        }
        else {
          reject(result);
        }
      })
      .catch(error => {
        console.error(error);
        reject(error)
      });
  });
}


/**
 * 入力チェック
 */
export const CheckPLMSettingInputData = (targetList: PLM_CSV_SET[], translation: any): string[] => {
  let list = targetList.filter((r) => r.isEdit);
  let errorMsgs: string[] = [];

  targetList.forEach((r, index) => {
    if (r.isEdit) {
      //string なので!だけでnullまたは空白チェック可能
      if (!r.PLM_NAME) {
        errorMsgs.push(`No:${index + 1} ` + i18next.t('PLMSetting.名称必須', '名称必須です'));
      }
      if (!r.PLM_USERID) {
        errorMsgs.push(`No:${index + 1} ` + i18next.t('PLMSetting.ユーザID必須', 'ユーザID称必須です'));
      }
      if (!r.PLM_PASSWD) {
        errorMsgs.push(`No:${index + 1} ` + i18next.t('PLMSetting.パスワード必須', 'パスワード必須です'));
      }
      if (r.PLM_IPADR === "0.0.0.0") {
        errorMsgs.push(`No:${index + 1} ` + i18next.t('PLMSetting.IPアドレス必須', 'IPアドレス必須です'));
      }
      if (!r.PLM_CSV_PATH) {
        errorMsgs.push(`No:${index + 1} ` + i18next.t('PLMSetting.保存場所必須', '保存場所必須です'));
        return false;
      }
    }
  });

  return errorMsgs;
}
